var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-slider',{attrs:{"tick-labels":_vm.ticksLabels,"min":1,"max":10,"step":"1","ticks":"always","tick-size":"4","disabled":_vm.sliderDisabled},model:{value:(_vm.skill.threshold),callback:function ($$v) {_vm.$set(_vm.skill, "threshold", $$v)},expression:"skill.threshold"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }